export default __webpack_public_path__ + "beb8463aa2d1adc5fa376e4d541b089d.svg";